import React, { useState } from "react";
import RequestForm from "./components/RequestForm";
import RequestDashboard from "./components/RequestDashboard";
import DeviceStatus from "./components/DeviceStatus";
import DeviceAlertSettings from "./components/DeviceAlertSettings";   // <-- NEW
import Login from "./components/Login"; 

function App() {
  const [token, setToken] = useState(null);  
  const [activeTab, setActiveTab] = useState("requests");
  // If not logged in → show Login page
  if (!token) {
    return <Login onLogin={(tok) => setToken(tok)} />;
  }


  return (
    <div className="min-h-screen flex flex-col items-center justify-start bg-gray-100 p-6">
      
      {/* Navigation Tabs */}
      <div className="flex space-x-6 mb-6">
        
        <button
          onClick={() => setActiveTab("requests")}
          className={`px-4 py-2 rounded-lg font-semibold ${
            activeTab === "requests" ? "bg-blue-500 text-white" : "bg-white text-gray-700"
          } shadow`}
        >
          Requests
        </button>

        <button
          onClick={() => setActiveTab("devices")}
          className={`px-4 py-2 rounded-lg font-semibold ${
            activeTab === "devices" ? "bg-blue-500 text-white" : "bg-white text-gray-700"
          } shadow`}
        >
          Devices
        </button>

        <button
          onClick={() => setActiveTab("alerts")}
          className={`px-4 py-2 rounded-lg font-semibold ${
            activeTab === "alerts" ? "bg-blue-500 text-white" : "bg-white text-gray-700"
          } shadow`}
        >
          Alerts
        </button>

      </div>

      {/* Content */}
      <div className="w-full max-w-5xl bg-white p-4 rounded-lg shadow">
        {activeTab === "requests" && (
          <>
            <RequestForm token={token} />
            <div className="mt-6">
              <RequestDashboard token={token} />
            </div>
          </>
        )}

        {activeTab === "devices" && <DeviceStatus token={token} />}

        {activeTab === "alerts" && <DeviceAlertSettings token={token} />}
      </div>
    </div>
  );
}

export default App;
